import PageHeader from '@/components/Layout/PageHeader';
import { Gear } from '@phosphor-icons/react';

export default function SettingsPage() {
  return (
    <div data-testid="settings-page">
      <PageHeader 
        title="Settings" 
        subtitle="System configuration and preferences"
      />
      
      <div className="page-content">
        <div className="bg-white border border-[#E2E8F0] rounded-lg p-8 text-center">
          <Gear size={48} className="mx-auto text-[#64748B] mb-4" />
          <h3 className="text-lg font-medium mb-2">Settings Coming Soon</h3>
          <p className="text-[#64748B]">
            System settings, Zoho integration configuration, and preferences will be available here.
          </p>
        </div>
      </div>
    </div>
  );
}
